import * as S from './styles'
import { useState, useEffect } from 'react'
import { useCart } from '../../../context/CartContext'
import { useNavigate } from 'react-router-dom'

const CatalogCart = () => {
  const { chatbotCartObj, chatbotCart } = useCart()
  const [cartQuantity, setCartQuantity] = useState(0)
  const navigate = useNavigate()
  
  const verifyCartQuantity = () => {
    let total = 0;
    if (chatbotCartObj) {
      total = Object.values(chatbotCartObj).reduce((sum, qty) => sum + qty, 0);
    }
    setCartQuantity(total)
  }

  useEffect(() => {
    verifyCartQuantity()
  }, [chatbotCart, chatbotCartObj])

  return (
    <S.CatalogCart onClick={() => navigate('/chatbot-catalog/cart')}>
      <S.CatalogCartWrapper>
        <S.CartIcon type='cart' />
        {cartQuantity > 0 && (
          <S.CatalogCartQuantityQtd>{cartQuantity}</S.CatalogCartQuantityQtd>
        )}
      </S.CatalogCartWrapper>
    </S.CatalogCart>
  )
}

export default CatalogCart
